module.exports = __webpack_public_path__ + "img/m_qr_step03.png";